import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  makeStyles,
  Paper,
  Button as MatButton,
  Divider,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import CryptoJS from "crypto-js";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";
import classNames from "classnames";

import AppConfig, {
  ADMIN_PERMISSIONS,
  SYSTEM_ROLE,
} from "../../config/AppConfig";
import AppDialog from "components/Dialog/AppDialog";
import ComponentLoading from "components/Common/ComponentLoading";
import {
  // fetchAccountList,
  getMe,
  login,
  socialLogin,
} from "../../store/slices/auth";
import AppNavbarLayout from "../../components/Navbars/AppNavbarLayout";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import AppButton from "../../components/CustomButtons/AppButton";
import AppColor from "../../utilities/AppColor";
import AdminLoginForm from "./Form/AdminLoginForm";
import moment from "moment-timezone";
import { getToken } from "../../utils/firebase";
import LogoIcon from "assets/icons/care-aid.png";
import AppleSignin from "react-apple-signin-auth";
// import UserLoginForm from "./Form/UserLoginForm";
// import SelectEmailForm from "./Form/SelectEmailForm";
import StorageHelper from "utilities/StorageHelper";
import { getCompanyConfig } from "store/slices/company";
import { fetchCompanyConfig } from "store/slices/company";
import { useMedia } from 'react-use';
import AppUtil from "utilities/AppUtil";
const { APPROVAL_STATUS } = AppConfig;

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const below600 = useMedia('(max-width: 600px)'); 
  const isMobile = AppUtil.mobileAndTabletCheck();

  const useStyles = makeStyles((theme) => ({
    ...styles(theme),
    appBar: {
      ...styles(theme).appBar,
      color: "#555555",
    },
    logoTitle: {
      width: '60%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: 40,
      "& img": {
        maxHeight: 40,
        minWidth: 100
      },
    },
    title: {
      color: AppColor.black,
      fontSize: "24px",
      fontWeight: "500",
      textAlign: "center",
    },
    description: {
      color: AppColor.mainColor,
      fontSize: "14px",
      textAlign: "center",
      fontWeight: "500",
      padding: below600 ? '0px' : '0px 300px'
    },
    logo: {
      display: "flex",
      justifyContent: "center",
      cursor: "pointer",
    },
    menuContainer: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    paper: {
      padding: "30px",
      borderRadius: 10,
    },
    signup: {
      color: AppColor.mainColor,
      textTransform: "unset",
      fontSize: 14,
      fontWeight: "600",
      whiteSpace: "nowrap",
      paddingLeft: "0.25rem",
      cursor: "pointer",
    },
    generalText: {
      fontSize: 14,
      color: AppColor.black,
    },
    margin: {
      marginTop: theme.spacing(2),
      padding: "1px 6px",
    },
    button: {
      backgroundColor: AppColor.white,
      fontSize: 14,
      fontWeight: "500",
      borderRadius: "50px",
      textTransform: "none",
      "& .MuiButton-label": {
        justifyContent: "space-between",
      },
    },
    dividerTextContainer: {
      marginTop: "-16px",
      color: AppColor.black,
      display: "flex",
      justifyContent: "center",
    },
    dividerText: {
      width: "fit-content",
      backgroundColor: "#f9f7f6",
      paddingRight: "5px",
      paddingLeft: "5px",
    },
    marginVertical: {
      marginTop: "100px",
      marginBottom: "100px",
    },
    companyName: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      margin: '0 15px',
      fontWeight: 'bold',
      color: 'black'
    }
  }));

  const classes = useStyles();

  const companyConfig = useSelector(getCompanyConfig) || {};
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  const listDomainSuperAdmin = process.env.REACT_APP_DOMAIN_SUPER_ADMIN.split(',');

  const [loading, setLoading] = useState(false);
  const [socialLoading, setSocialLoading] = useState(false);
  const [emailLogin, setEmailLogin] = useState(null);
  const [token, setToken] = useState(null);
  const timezone = moment.tz.guess(true);
  
  useEffect(() => {
    if (listDomainSuperAdmin.indexOf(hostname) <= -1 && (history.location.pathname.includes("admin") || history.location.pathname.includes("/auth/login"))) {
      history.push('/auth/company/login');
    }
    if (listDomainSuperAdmin.indexOf(hostname) > -1 && history.location.pathname.includes("worker")) {
      history.push('/auth/login');
    }
  }, [hostname]);

  useEffect(() => {
    dispatch(fetchCompanyConfig({ domain: hostname }));
  }, []);

  const _navigateToUser = (status) => {
    let path = "/on-board";
    if (
      status === AppConfig.APPROVAL_STATUS.ACTIVE ||
      status === AppConfig.APPROVAL_STATUS.WAITING_FOR_APPROVAL
    ) {
      path = "/dashboard";
    }
    // }
    history.push(path);
  };

  const _getLoginType = () => {
    return history.location.pathname.includes("client")
      ? AppConfig.LOGIN_TYPES.CLIENT
      : history.location.pathname.includes("worker")
      ? AppConfig.LOGIN_TYPES.WORKER
      : history.location.pathname.includes("company")
      ? AppConfig.LOGIN_TYPES.COMPANY
      : AppConfig.LOGIN_TYPES.ADMIN;
  };

  const _getType = () => {
    return history.location.pathname.includes("client")
      ? "client"
      : history.location.pathname.includes("worker")
      ? "worker"
      : history.location.pathname.includes("company")
      ? "company"
      : "admin";
  };

  const _navigateToForgotPassword = () => {
    history.push(`/auth/${_getType()}/forgot-password`);
  };
  const checkIsLoggedIn = () => {
    const authInfo = StorageHelper.getLocalObject(AppConfig.STORAGE_KEYS.user);
    const isAuthen = StorageHelper.getCookie(AppConfig.STORAGE_KEYS.token);
    if (isAuthen && authInfo) {
    return true;
    } else {
      return false;
    }
  }
  const submit = async (data) => {
    if(checkIsLoggedIn()) {
      window.location.reload();
    } else {
      const request = {
        email: data.email.trim(),
        domain: hostname,
        passwordHash: CryptoJS.MD5(data.password).toString(),
        keepMeLogin: data.keepMeLogin,
        loginType: _getLoginType(),
        timezone: timezone,
        ...(_getType() !== "worker" && {
          fcmToken: (await getToken()) || "",
        }),
      };
      if (_getLoginType() === AppConfig.LOGIN_TYPES.WORKER && token) {
        request["tokenUpdateProfile"] = token;
      }
      if (
        _getLoginType() === AppConfig.LOGIN_TYPES.WORKER ||
        _getLoginType() === AppConfig.LOGIN_TYPES.CLIENT
      ) {
        request["id"] = data.companyId;
      }
      setLoading(true);
      const { payload } = await dispatch(login(request));
      setLoading(false);
      if (payload) {
        const result = await dispatch(getMe());
        if (payload.systemRole === SYSTEM_ROLE.SUPER_ADMIN) {
          history.push("/admin/dashboard");
        } else if (payload.systemRole === SYSTEM_ROLE.MANAGER) {
          if (result.payload) {
            if (result.payload.permissions.length === 0) {
              history.push("/admin/profile");
            } else {
              handlePermissionManager(result.payload.permissions);
            }
          }
        } else if (payload.systemRole === SYSTEM_ROLE.COMPANY) {
          if (payload.owner) {
            if (payload.approvalStatus !== APPROVAL_STATUS.ACTIVE) {
              history.push("/admin/profile");
            } else {
              history.push("/admin/dashboard");
            }
          } else {
            if (result.payload) {
              if (result.payload.permissions.length === 0) {
                history.push("/admin/profile");
              } else {
                handlePermissionCompanyUser(result.payload.permissions);
              }
            }
          }
        }
      }
    }
  };

  const handlePermissionManager = (permissions) => {
    let path = "/admin/profile";
    if (permissions.indexOf(ADMIN_PERMISSIONS.dashboard.id) > -1) {
      path = "/admin/dashboard";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.users.id) > -1) {
      path = "/admin/users";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.company.id) > -1) {
      path = "/admin/company";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.rates.id) > -1) {
      path = "/admin/rates";
    } else if (
      permissions.indexOf(ADMIN_PERMISSIONS.subscriptionPlan.id) > -1
    ) {
      path = "/admin/subscription-plan";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.transactions.id) > -1) {
      path = "/admin/transactions";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.accountSoftware.id) > -1) {
      path = "/admin/account-software";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.paymentGateway.id) > -1) {
      path = "/admin/payment-gateway";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.options.id) > -1) {
      path = "/admin/options";
    }
    history.push(path);
  };
  const handlePermissionCompanyUser = (permissions) => {
    let path = "/admin/profile";
    if (permissions.indexOf(ADMIN_PERMISSIONS.dashboard.id) > -1) {
      path = "/admin/dashboard";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.users.id) > -1) {
      path = "/admin/users";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.jobs.id) > -1) {
      path = "/admin/jobs";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.workers.id) > -1) {
      path = "/admin/workers";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.clients.id) > -1) {
      path = "/admin/clients";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.booking.id) > -1) {
      path = "/admin/booking";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.billing.id) > -1) {
      path = "/admin/billing";
    } else if (permissions.indexOf(ADMIN_PERMISSIONS.payroll.id) > -1) {
      path = "/admin/payroll";
    }
    history.push(path);
  };

  const _onFacebookResponse = async (data) => {
    if (data && data.accessToken) {
      setSocialLoading(true);
      const dataRequest = {
        tokenId: data.accessToken,
        domain: hostname,
        loginType: _getLoginType(),
        timezone: timezone,
        ...(_getType() !== "worker" && {
          fcmToken: (await getToken()) || "",
        }),
      };
      if (token) {
        dataRequest.tokenUpdateProfile = token;
      }
      dispatch(
        socialLogin({
          type: AppConfig.SOCIAL_LOGIN_TYPES.FACEBOOK,
          data: dataRequest,
        })
      ).then(({ payload }) => {
        setSocialLoading(false);
        if (payload) {
          if (window.FB) {
            window.FB.getLoginStatus(response => {
              if (response.status === 'connected') {
                // window.FB.api('/me/permissions', 'delete', null, () => window.FB.logout(response => console.log('logout', response)));
                window.FB.logout(response => console.log('logout', response));
              }
            });
          }
          if (payload.systemRole === SYSTEM_ROLE.COMPANY) {
            if (payload.owner) {
              if (payload.approvalStatus !== APPROVAL_STATUS.ACTIVE) {
                history.push("/admin/profile");
              } else {
                history.push("/admin/dashboard");
              }
            }
          } else {
          _navigateToUser(payload.approvalStatus);
          }
        } else {
          if (window.FB) {
            window.FB.getLoginStatus(response => {
              if (response.status === 'connected') {
                // window.FB.api('/me/permissions', 'delete', null, () => window.FB.logout(response => console.log('logout', response)));
                window.FB.logout(response => console.log('logout', response));
              }
            });
          }
        }
      });
    }
  };

  const _onGoogleFailed = (data) => {
    console.log(data);
  };

  const _onGoogleResponse = async (data) => {
    if (data && data.tokenId) {
      setSocialLoading(true);
      const dataRequest = {
        tokenId: data.tokenId,
        domain: hostname,
        loginType: _getLoginType(),
        timezone: timezone,
        ...(_getType() !== "worker" && {
          fcmToken: (await getToken()) || "",
        }),
      };
      if (token) {
        dataRequest.tokenUpdateProfile = token;
      }
      dispatch(
        socialLogin({
          type: AppConfig.SOCIAL_LOGIN_TYPES.GOOGLE,
          data: dataRequest,
        })
      ).then(({ payload }) => {
        setSocialLoading(false);
        if (payload) {
          if (payload.systemRole === SYSTEM_ROLE.COMPANY) {
            if (payload.owner) {
              if (payload.approvalStatus !== APPROVAL_STATUS.ACTIVE) {
                history.push("/admin/profile");
              } else {
                history.push("/admin/dashboard");
              }
            }
          } else {
          _navigateToUser(payload.approvalStatus);
          }
        }
      });
    }
  };

  const _loginWithAppleResponse = async (response) => {
    // console.log(response);
    setSocialLoading(true);
    const dataRequest = {
      tokenId: response?.authorization?.id_token,
      domain: hostname,
      loginType: _getLoginType(),
      timezone: timezone,
      ...(_getType() !== "worker" && {
        fcmToken: (await getToken()) || "",
      }),
    };
    
    if (token) {
      dataRequest.tokenUpdateProfile = token;
    }
    dispatch(
      socialLogin({
        type: AppConfig.SOCIAL_LOGIN_TYPES.APPLE,
        data: dataRequest,
      })
    ).then(({ payload }) => {
      setSocialLoading(false);
      if (payload) {
        _navigateToUser(payload.approvalStatus);
      }
    });
  };

  const _onFacebookFailure = (data) => {
    console.log('data', data);
  }

  useEffect(() => {
    if (window.FB) {
      window.FB.init({
        appId:  process.env.REACT_APP_FACEBOOK_CLIENT_ID,
        status: true,
        xfbml: true,
        version: 'v2.7'
      })
    }
  }, [window.FB]);

  useEffect(() => {
    const search = history.location.search;
    if (search && (search.includes('email=') || search.includes('token='))) {
      const param = search.replace('?', '');
      for (const item of param.split('&')) {
        if (item.includes('email=')) {
          const email = item.replace('email=', '');
          setEmailLogin(email);
        }
        if (item.includes('token=')) {
          const token = item.replace('token=', '');
          setToken(token);
        }
      }
    }
  }, [history]);
  
  return (
    <div style={{ width: "100%" }}>
      <Helmet>
        <title>{t("title.login")}</title>
      </Helmet>
      <AppNavbarLayout>
        <div className={classes.flex}>
          <Box className={classes.logoTitle}>
            {
              !pathname.includes('auth/login') && companyConfig
              ? !isMobile && <>
                <img src={companyConfig.logoAws3Link ? companyConfig.logoAws3Link : LogoIcon} />
                <span className={classes.companyName}>{companyConfig.organizationName}</span>
              </>
              : <img src={LogoIcon} />
            }
          </Box>
        </div>
        <div className={classes.menuContainer}>
          {((history.location.pathname.includes("company") && !(listDomainSuperAdmin.indexOf(hostname) <= -1)) || (history.location.pathname.includes("worker") && (listDomainSuperAdmin.indexOf(hostname) <= -1))) && (
              <AppButton
                label={`${t("button.sign_up")}`}
                onClick={() => {
                  history.push("/auth/signup", { signupType: _getType() })
                  // history.location.pathname.includes("company")
                  //   ? history.push("/auth/signup", { signupType: "company" })
                  //   : history.push("/auth/signup");
                }}
                style={{
                  whiteSpace: "nowrap",
                }}
              />
            )}
        </div>
      </AppNavbarLayout>
      <div className={`container-fluid ${classes.marginVertical}`}>
        <div style={{ marginBottom: "25px" }}>
          <h5 className={classes.title}>{t("title.login")}</h5>
          <h5 className={classes.description}>{companyConfig && companyConfig.organizationName !== null ? t("text.login_company", { company_name: companyConfig.organizationName }) : t("text.login")}</h5>
        </div>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <Paper className={classes.paper} elevation={5}>
              <AdminLoginForm
                onSubmit={submit}
                emailLogin={emailLogin}
                loading={loading}
                navigateToForgotPassword={_navigateToForgotPassword}
                isNavigateforgotPassword={(history.location.pathname.includes("company") && (listDomainSuperAdmin.indexOf(hostname) <= -1)) ||
                (history.location.pathname.includes("worker") && (listDomainSuperAdmin.indexOf(hostname) <= -1))}
              />
            </Paper>
            <div>
              {((history.location.pathname.includes("company") && !(listDomainSuperAdmin.indexOf(hostname) <= -1)) || (history.location.pathname.includes("worker") && (listDomainSuperAdmin.indexOf(hostname) <= -1))) && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="baseline"
                    mt={3}
                    mb={2}
                  >
                    <p className={classes.generalText}>
                      {t("text.no_care_aid_account")}
                    </p>
                    <div
                      className={classes.signup}
                      onClick={() =>
                        history.push("/auth/signup", {
                          signupType: _getType(),
                        })
                      }
                    >
                      {t("label.sign_up_here")}
                    </div>
                  </Box>
                )}
            </div>
            {!history.location.pathname.includes("auth/login") && (
              <div>
                <Divider style={{ backgroundColor: AppColor.black, marginTop: '3rem' }} />
                <div className={classes.dividerTextContainer}>
                  <div className={classes.dividerText}>{t("text.or")}</div>
                </div>
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
                  fields="name,email,picture"
                  isSdkLoaded={true}
                  callback={_onFacebookResponse}
                  disableMobileRedirect
                  onFailure={_onFacebookFailure}
                  render={({ onClick }) => (
                    <MatButton
                      variant="outlined"
                      fullWidth
                      className={classNames({
                        [classes.margin]: true,
                        [classes.button]: true,
                      })}
                      style={{}}
                      onClick={onClick}
                      startIcon={
                        <i
                          style={{ fontSize: "35px", color: "#3b5998" }}
                          className="fab fa-facebook"
                        />
                      }
                    >
                      <span style={{ width: "100%" }}>
                        {t("button.login_with_facebook")}
                      </span>
                    </MatButton>
                  )}
                />
                <GoogleLogin
                  clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                  onSuccess={_onGoogleResponse}
                  isSignedIn={false}
                  onFailure={_onGoogleFailed}
                  autoLoad={false}
                  cookiePolicy={"single_host_origin"}
                  prompt="select_account"
                  redirectUri={`${window.location.origin}`}
                  render={({ onClick }) => (
                    <MatButton
                      variant="outlined"
                      fullWidth
                      className={classNames({
                        [classes.margin]: true,
                        [classes.button]: true,
                      })}
                      style={{}}
                      onClick={onClick}
                      startIcon={
                        <i
                          style={{ fontSize: "35px", color: "#4285F4" }}
                          className="fab fa-google"
                        />
                      }
                    >
                      <span style={{ width: "100%" }}>
                        {t("button.login_with_google")}
                      </span>
                    </MatButton>
                  )}
                />
                {history.location.pathname.includes("worker") && (
                  <AppleSignin
                    /** Auth options passed to AppleID.auth.init() */
                    authOptions={{
                      /** Client ID - eg: 'com.example.com' */
                      clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
                      /** Requested scopes, seperated by spaces - eg: 'email name' */
                      scope: "email name",
                      /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
                      redirectURI:
                      `${window.location.origin}${window.location.pathname}` || process.env.REACT_APP_APPLE_SIGN_IN_REDIRECT_URL,
                      /** State string that is returned with the apple response */
                      state: "state",
                      /** Nonce */
                      nonce: "nonce",
                      /** Uses popup auth instead of redirection */
                      usePopup: true,
                    }} // REQUIRED
                    /** General props */
                    uiType="dark"
                    /** className */
                    className="apple-auth-btn"
                    /** Removes default style tag */
                    noDefaultStyle={false}
                    /** Allows to change the button's children, eg: for changing the button text */
                    buttonExtraChildren="Continue with Apple"
                    /** Extra controlling props */
                    /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */
                    onSuccess={_loginWithAppleResponse} // default = undefined
                    /** Called upon signin error */
                    onError={(error) => console.error(error)} // default = undefined
                    /** Skips loading the apple script if true */
                    skipScript={false} // default = undefined
                    /** Apple image props */
                    iconProp={{ style: { marginTop: "10px" } }} // default = undefined
                    /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */
                    render={({ onClick }) => (
                      <MatButton
                        variant="outlined"
                        fullWidth
                        className={classNames({
                          [classes.margin]: true,
                          [classes.button]: true,
                        })}
                        style={{}}
                        onClick={onClick}
                        startIcon={
                          <div
                            style={{
                              width: "35px",
                              height: "35px",
                              borderRadius: "18px",
                              backgroundColor: "#555555",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <i
                              style={{ fontSize: "25px", color: "#ffffff" }}
                              className="fab fa-apple"
                            />
                          </div>
                        }
                      >
                        <span style={{ width: "100%" }}>
                          {t("button.login_with_apple")}
                        </span>
                      </MatButton>
                    )}
                  />
                )}
              </div>
            )}
          </Grid>
        </Grid>
      </div>
      <AppDialog open={socialLoading} noCloseButton noTitle>
        <Box my={3}>
          <ComponentLoading />
        </Box>
      </AppDialog>
    </div>
  );
};

export default withRouter(Login);